var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6291 1.97205C17.4217 1.20092 16.8137 0.593043 16.0427 0.385401C14.6341 0 8.9998 0 8.9998 0C8.9998 0 3.36567 0 1.95711 0.370789C1.20092 0.578212 0.578102 1.20103 0.370679 1.97205C0 3.3805 0 6.30144 0 6.30144C0 6.30144 0 9.2371 0.370679 10.6308C0.578321 11.4019 1.18609 12.0097 1.95722 12.2174C3.3805 12.6029 9.00002 12.6029 9.00002 12.6029C9.00002 12.6029 14.6341 12.6029 16.0427 12.2321C16.8138 12.0246 17.4217 11.4167 17.6294 10.6457C17.9999 9.2371 17.9999 6.31627 17.9999 6.31627C17.9999 6.31627 18.0148 3.3805 17.6291 1.97205ZM7.20595 8.99991V3.60297L11.8912 6.30144L7.20595 8.99991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b861896de61ab6bf365272215d20c10b.svg";
export { ForwardRef as ReactComponent };